// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/assets/images/logo/inpark/inpark-140.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/assets/images/icons/v2/24/24-error.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `aptl-app {
  width: 100%;
  height: 100%;
  background-color: #F2F2F2;
  overflow: auto;
}
aptl-app > header {
  background-color: #122AFF;
}
aptl-app > header div.title {
  display: flex;
  flex-direction: row;
  max-width: 820px;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px;
  margin: 0 auto;
}
aptl-app > header div.title div.logo {
  width: 40px;
  height: 48px;
  background-color: #FFFFFF;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
aptl-app > header div.title div.label {
  font-family: "Incinet Semi Bold", sans-serif;
  font-size: 18px;
  font-style: normal;
  line-height: normal;
  color: #FFFFFF;
}
aptl-app > article {
  max-width: 820px;
  box-sizing: border-box;
  padding: 32px 16px 64px 16px;
  margin: 0 auto;
}
aptl-app > article h1 {
  font-family: "Incinet Semi Bold", sans-serif;
  font-size: 21px;
  font-style: normal;
  line-height: normal;
  color: #181818;
  margin-bottom: 32px;
  text-align: center;
}
aptl-app > article p {
  font-family: "Incinet Regular", sans-serif;
  font-size: 14px;
  font-style: normal;
  line-height: normal;
  color: #181818;
  margin-bottom: 12px;
}
aptl-app > article div.pinpad {
  margin-bottom: 16px;
}
aptl-app > article div.pinpad div.row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
  padding: 4px 0;
}
aptl-app > article div.pinpad div.row div.number {
  font-family: "Incinet Semi Bold", sans-serif;
  font-size: 21px;
  font-style: normal;
  line-height: normal;
  width: 286px;
  height: 64px;
  color: #181818;
  box-sizing: border-box;
  text-align: center;
  padding: 12px 12px 0 12px;
  margin-bottom: 16px;
  border: 2px solid #FFFFFF;
  border-radius: 6px;
}
aptl-app > article div.pinpad div.row div.button {
  font-family: "Incinet Semi Bold", sans-serif;
  font-size: 21px;
  font-style: normal;
  line-height: normal;
  cursor: pointer !important;
  user-select: none;
  width: 90px;
  box-sizing: border-box;
  color: #181818;
  background-color: #FFFFFF;
  text-align: center;
  padding: 24px 16px;
  border-radius: 6px;
}
aptl-app > article div.pinpad div.row div.button:active {
  background-color: rgba(22, 22, 22, 0.0392156863);
}
aptl-app > article div.pinpad div.row div.button-clear {
  color: #FFFFFF;
  background-color: #FF1267;
}
aptl-app > article div.pinpad div.row div.button-ok {
  background-color: #12FF67;
}
aptl-app > article canvas {
  display: none;
}
aptl-app > article div.video {
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: center;
  margin-bottom: 16px;
  max-height: 50vh;
  background-color: #E9E9E9;
  overflow: hidden;
  border-radius: 6px;
}
aptl-app > article div.video video {
  width: 100%;
  box-sizing: border-box;
}
aptl-app > article div.video div.empty {
  display: flex;
  flex-direction: row;
  transition: all 150ms cubic-bezier(0, 0, 0.38, 0.9) 0ms;
  transition-property: opacity;
  position: absolute;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
  gap: 8px;
  background-color: #FF1267;
  padding: 8px 16px 8px 8px;
  border-radius: 6px;
}
aptl-app > article div.video div.empty div.icon {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  width: 24px;
  height: 24px;
  background-color: #FFFFFF;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
aptl-app > article div.video div.empty div.label {
  font-family: "Incinet Regular", sans-serif;
  font-size: 14px;
  font-style: normal;
  line-height: normal;
  color: #FFFFFF;
  white-space: nowrap;
}
aptl-app > article div.video div.empty-hidden {
  opacity: 0;
}
aptl-app > article div.video submit-button {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
}
@media print {
  aptl-app {
    height: unset;
    overflow: unset;
  }
}`, "",{"version":3,"sources":["webpack://./src/aptl/components/aptl-app/aptl-app.scss","webpack://./src/aptl/components/styles/_colors.scss","webpack://./src/aptl/components/styles/_mixins.scss","webpack://./src/aptl/components/styles/_styles.scss"],"names":[],"mappings":"AAMA;EACE,WAAA;EACA,YAAA;EACA,yBCJQ;EDKR,cAAA;AALF;AAOE;EACE,yBCZQ;ADOZ;AAOI;EEoBF,aAAA;EACA,mBAAA;EFnBI,gBAbM;EAcN,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;AAJN;AAMM;EACE,WAAA;EACA,YAAA;EACA,yBCzBG;ED0BH,mDAAA;AAJR;AAOM;EE1BJ,4CAAA;ECwDA,eAAA;EACA,kBAAA;EACA,mBAAA;EH9BM,cC/BG;AD6BX;AAOE;EACE,gBAnCQ;EAoCR,sBAAA;EACA,4BAAA;EACA,cAAA;AALJ;AAOI;EEvCF,4CAAA;EC+DA,eAAA;EACA,kBAAA;EACA,mBAAA;EHxBI,cC3CI;ED4CJ,mBAAA;EACA,kBAAA;AAFN;AAKI;EElDF,0CAAA;ECIA,eAAA;EACA,kBAAA;EACA,mBAAA;EH8CI,cClDI;EDmDJ,mBAAA;AAAN;AAGI;EACE,mBAAA;AADN;AAGM;EEzBJ,aAAA;EACA,mBAAA;EF0BM,uBAAA;EACA,QAAA;EACA,cAAA;AAAR;AAEQ;EE7DN,4CAAA;EC+DA,eAAA;EACA,kBAAA;EACA,mBAAA;EHFQ,YAAA;EACA,YAAA;EACA,cCnEA;EDoEA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAGV;AAAQ;EE1EN,4CAAA;EC+DA,eAAA;EACA,kBAAA;EACA,mBAAA;EDZA,0BAAA;EACA,iBAAA;EFuBQ,WAAA;EACA,sBAAA;EACA,cCjFA;EDkFA,yBCnFC;EDoFD,kBAAA;EACA,kBAAA;EACA,kBAAA;AAMV;AAJU;EACE,gDClFJ;ADwFR;AAHU;EACE,cC7FD;ED8FC,yBCzFC;AD8Fb;AAFU;EACE,yBC5FC;ADgGb;AAEI;EACE,aAAA;AAAN;AAGI;EEtEF,aAAA;EACA,sBAAA;EFuEI,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBChHI;EDiHJ,gBAAA;EACA,kBAAA;AAAN;AAEM;EACE,WAAA;EACA,sBAAA;AAAR;AAGM;EE1FJ,aAAA;EACA,mBAAA;EA+CA,uDAAA;EACA,4BAAA;EF4CM,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;EACA,yBC/HK;EDgIL,yBAAA;EACA,kBAAA;AACR;AACQ;EE9GN,WF+G0C;EE9G1C,YF8GgD;EE7GhD,eF6G0C;EE5G1C,gBF4GgD;EACxC,WAAA;EACA,YAAA;EACA,yBC5IC;ED6ID,mDAAA;AAIV;AADQ;EEjJN,0CAAA;ECIA,eAAA;EACA,kBAAA;EACA,mBAAA;EH6IQ,cClJC;EDmJD,mBAAA;AAMV;AAHQ;EACE,UAAA;AAKV;AADM;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;AAGR;AAKE;EAnKF;IAoKI,aAAA;IACA,eAAA;EAFF;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
